import { motion } from "framer-motion";
import { Info } from "lucide-react";
import { SERVICES, REVISION_NOTE } from "../data/services";
import { ServiceChapter } from "./ServiceChapter";

export const Services = () => {
    return (
        <section id="servicios" className="py-24 md:py-32 bg-cream">
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
                    className="mb-8"
                >
                    <p className="font-mono text-xs uppercase tracking-[0.3em] text-coral mb-4">
                        Packs de servicios
                    </p>
                    <h2 className="font-display text-4xl md:text-6xl font-black tracking-tighter max-w-3xl leading-none">
                        Precios claros. <span className="italic font-medium text-coral">Sin sorpresas.</span>
                    </h2>
                </motion.div>

                <motion.p
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, delay: 0.2 }}
                    className="flex items-start gap-3 max-w-2xl text-sm text-slateblue border-l-2 border-coral pl-4 mb-4"
                    data-testid="revision-note"
                >
                    <Info size={16} className="mt-0.5 shrink-0 text-coral" />
                    {REVISION_NOTE}
                </motion.p>

                <div>
                    {SERVICES.map((s) => (
                        <ServiceChapter key={s.id} service={s} />
                    ))}
                </div>
            </div>
        </section>
    );
};
